import { matchPath, useLocation } from "react-router-dom";
import { useMemo } from "react";

const useRoutesMatch = (
  paths: (string | string[])[] | void,
  exact = true
): [number, string] | undefined => {
  const location = useLocation();

  const checkPathMatch = (path: string) =>
    matchPath(location.pathname, {
      path,
      exact,
      strict: false,
    });

  return useMemo(() => {
    if (!paths) return;
    for (let [index, path] of paths.entries()) {
      if (Array.isArray(path)) {
        for (let subPath of path) {
          if (checkPathMatch(subPath)) {
            return [index, subPath];
          }
        }
        continue;
      }
      if (checkPathMatch(path)) {
        return [index, path];
      }
    }
  }, [paths, location.pathname]);
};

export default useRoutesMatch;
